export const NavData = [
  {
    title: "General Settings",
    link: "/general-settings",
  },
  {
    title: "Home",
    link: "/home",
  },
  {
    title: "For Business",
    link: "/forbusiness",
  },
  {
    title: "For Individuals",
    link: "/forindividuals",
  },
  {
    title: "About Us",
    link: "/aboutus",
  },
  {
    title: "Resources",
    link: "/resources",
  },
  {
    title: "Contact Us",
    link: "/contactUs",
  },
  {
    title: "Footer",
    link: "/footer",
  },
  {
    title: "Admin",
    link: "/admin/view",
  },
  {
    title: "Buttons",
    link: "/buttons",
  },
  {
    title: "Theme Settings",
    link: "/theme-settings",
  },
  {
    title: "Document Settings",
    link: "/document-settings",
  },
  {
    title: "Email Template Settings",
    link: "/email-template-settings",
  },
  {
    title: "Files",
    link: "/eligibility-files",
  },
  {
    title: "Partners",
    link: "/partners",
  },
  // {
  //   title: "Discount Info",
  //   link: "/coupons",
  // },
  // {
  //   title: "",
  //   link: "",
  // },
  // {
  //   title: "",
  //   link: "",
  // },
  // {
  //   title: "Log Out",
  //   link: "/",
  // },
];
